import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../../hooks/hooks';
import { useParams } from 'react-router-dom';
import { orders } from '../../redux/orders/action';
import { useSelector } from 'react-redux';
import { selectOrdersPrintItem } from '../../redux/orders/selector';
import { format } from '../services/date.service';


const Invoice = () => {
	const dispatch = useAppDispatch()
	const parmas: any = useParams()
	const orderEwayData = useSelector(selectOrdersPrintItem)
	const [isQuery, setIsQuery] = useState<boolean>(false)
	const [
		orderEway,
		setOrderEway
	] = useState<any>({})
	const eWayBillData = {
		"eWayBillNo": orderEway?.BasicDetail?.EwayBillNumber,
		"dateOfGeneration": format(orderEway?.BasicDetail?.StartDateUtc),
		"validUntil": format(orderEway?.BasicDetail?.EndDateUtc),
		"supplier": {
			"name": orderEway?.SupplierDetail?.Name,
			"gstin": orderEway?.SupplierDetail?.GSTNumber,
			"address": `${orderEway?.SupplierDetail?.Address?.building},${orderEway?.SupplierDetail?.Address?.locality},${orderEway?.SupplierDetail?.Address?.city},${orderEway?.SupplierDetail?.Address?.state}-${orderEway?.SupplierDetail?.Address?.area_code},${orderEway?.SupplierDetail?.Address?.country}.`
		},
		"recipient": {
			"name": orderEway?.RecipientDetail?.Name,
			"gstin": orderEway?.RecipientDetail?.GSTNumber,
			"address": `${orderEway?.RecipientDetail?.Address?.locality},${orderEway?.RecipientDetail?.Address?.city},${orderEway?.RecipientDetail?.Address?.state}-${orderEway?.RecipientDetail?.Address?.area_code},${orderEway?.RecipientDetail?.Address?.country}.`
		},
		"transportation": {
			"mode": orderEway?.TransportationDetail?.ModeOfTransport,
			"transporterName": orderEway?.TransportationDetail?.TransporterName,
			"transporterId": orderEway?.TransportationDetail?.TransporterId,
			"vehicleNumber": orderEway?.TransportationDetail?.VehicleNumber,
			"distance": orderEway?.TransportationDetail?.TotalDistance,
		},
		"goods": orderEway?.OrderDetail?.order_items,
	}
	const fetchOrderEwayById = async () => {
		await dispatch(orders.resetAction({ actionType: 'print' }))
		await dispatch(orders.print({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/eway-bill`, entity: 'orders', jsonData: {


				Records: [
					{
						context: {},
						Message: {
							EwayBillNumber: parmas?.id
						}
					}
				]

			}
		}))
		await setIsQuery(true)


	}
	const fetchDataOrder = async () => {
		await setOrderEway(orderEwayData?.result?.items?.Message)
		await window.print()
	}
	useEffect(() => {

		fetchOrderEwayById()


	}, []);

	useEffect(() => {

		if (isQuery && orderEwayData?.isSuccess) {
			fetchDataOrder()
		}

	}, [isQuery]);


	return (
		<div className="p-6 max-w-4xl mx-auto bg-white border border-gray-200 shadow-md rounded-lg">
			<header className="mb-6">
				<h1 className="text-2xl font-semibold text-center">E-Way Bill</h1>
			</header>

			<section className="mb-6 mx-10">
				<h2 className="text-lg font-semibold">Details of Goods and Parties</h2>
				<div className="flex flex-row justify-between items-center mx-5">
					<div className="flex flex-col space-y-5 justify-around items-start">
						<div className="mt-4">
							<h3 className="font-semibold mb-1 text-sm">From (Supplier):</h3>
							<div className="font-normal text-sm">{eWayBillData?.supplier?.name}</div>
							<div className="font-normal text-sm">GSTIN: {eWayBillData?.supplier?.gstin}</div>
							<div className="font-normal text-sm w-[400px]">{eWayBillData?.supplier?.address}</div>
						</div>

						<div className="mt-4">
							<h3 className="font-semibold mb-1 text-sm">To (Recipient):</h3>
							<div className="font-normal text-sm">{eWayBillData?.recipient?.name}</div>
							<div className="font-normal text-sm">GSTIN: {eWayBillData?.recipient?.gstin}</div>
							<div className="font-normal text-sm w-[400px]">{eWayBillData?.recipient?.address}</div>
						</div>
					</div>
					<div className="flex flex-col space-y-5 justify-around items-start">
						<div>
							<div className="font-semibold text-sm">E-Way Bill No:</div>
							<div className="font-normal text-sm">{eWayBillData?.eWayBillNo}</div>
						</div>
						<div>
							<div className="font-semibold text-sm">Date of Generation:</div>
							<div className="font-normal text-sm">{eWayBillData?.dateOfGeneration}</div>
						</div>
						<div>
							<div className="font-semibold text-sm ">Valid Until:</div>
							<div className="font-normal text-sm">{eWayBillData?.validUntil}</div>
						</div>
					</div>
				</div>
			</section>

			<section className="mb-6 mx-10">
				<h2 className="text-lg font-semibold mb-3">Transportation Details</h2>
				<table className=" border-x border-y border-gray-500 mx-5">
					<tr className='p-1 border-x border-y border-gray-500' >
						<td className="font-semibold text-sm w-48 p-1">Mode of Transport</td>
						<td className="font-normal text-sm p-1">{eWayBillData?.transportation?.mode}</td>
					</tr>
					<tr className='p-1 border-x border-y border-gray-500'>
						<td className="font-semibold text-sm w-48 p-1">Transporter Name</td>
						<td className="font-normal text-sm p-1">{eWayBillData?.transportation?.transporterName}</td>
					</tr>
					<tr className='p-1 border-x border-y border-gray-500'>
						<td className="font-semibold text-sm w-48 p-1">Transporter ID</td>
						<td className="font-normal text-sm p-1">{eWayBillData?.transportation?.transporterId}</td>
					</tr>
					<tr className='p-2 border-x border-y border-gray-500'>
						<td className="font-semibold text-sm w-48 p-1">Vehicle Number</td>
						<td className="font-normal text-sm p-1">{eWayBillData?.transportation?.vehicleNumber}</td>
					</tr>
					<tr className='p-1 border-x border-y border-gray-500'>
						<td className="font-semibold text-sm w-48 p-1">Distance (in KM)</td>
						<td className="font-normal text-sm p-1">{eWayBillData?.transportation?.distance}</td>
					</tr>
				</table>
			</section>

			<section className="mb-6 mx-10">
				<h2 className="text-lg font-semibold">Goods Details</h2>
				<table className="w-full border-collapse border border-gray-300">
					<thead>
						<tr className="bg-gray-100 text-xs">
							<th className="border border-gray-300 px-4 py-2 text-left">Category</th>
							<th className="border border-gray-300 px-4 py-2 text-right">HSN Code</th>
							<th className="border border-gray-300 px-4 py-2 text-right">Quantity</th>
							<th className="border border-gray-300 px-4 py-2 text-right">Unit</th>
							<th className="border border-gray-300 px-4 py-2 text-right">Value (₹)</th>
							<th className="border border-gray-300 px-4 py-2 text-right">Taxable Amount (₹)</th>
							<th className="border border-gray-300 px-4 py-2 text-right">IGST (%)</th>
							<th className="border border-gray-300 px-4 py-2 text-right">IGST Amount (₹)</th>
						</tr>
					</thead>
					<tbody>
						{eWayBillData?.goods?.map((item: any, index: any) => (
							<tr key={index} className='text-xs'>
								<td className="border border-gray-300 px-4 py-2">{item.Category}</td>
								<td className="border border-gray-300 px-4 py-2 text-right">{item.HSNCode}</td>
								<td className="border border-gray-300 px-4 py-2 text-right">{item.quantity}</td>
								<td className="border border-gray-300 px-4 py-2 text-right">{item.weight}</td>
								<td className="border border-gray-300 px-4 py-2 text-right">₹{orderEway?.OrderDetail?.TotalAmount.toFixed(2)}</td>
								<td className="border border-gray-300 px-4 py-2 text-right">₹0.00</td>
								<td className="border border-gray-300 px-4 py-2 text-right">0%</td>
								<td className="border border-gray-300 px-4 py-2 text-right">₹{orderEway?.OrderDetail?.TotalAmount.toFixed(2)}</td>
							</tr>
						))}
					</tbody>
				</table>
			</section>
		</div>
	);
};

const EWayBill = () => {

	return (
		<div className="bg-gray-100 min-h-screen flex justify-center items-center">
			<Invoice />
		</div>
	);
};


export default EWayBill;
